














































































































































































































































































import Vue from 'vue'
import PrintAction from './components/PrintAction.vue'

export default Vue.extend({
  name: 'pilot-print',
  components: { PrintAction },
  props: {
    pilot: {
      type: Object,
      required: true,
    },
  },
})
